module.exports = __webpack_public_path__ + "static/img/food.af9413e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/kfit/food.jpg
// module id = hJj0
// module chunks = 1